// extracted by mini-css-extract-plugin
module.exports = {"button":"NewDataField_button__Rhlug","eventsSelector":"NewDataField_eventsSelector__QEl_r","sponsorsLayoutBackground":"NewDataField_sponsorsLayoutBackground__1olJ3"};